/* eslint-disable @next/next/no-html-link-for-pages */
import { Box } from "@chakra-ui/react";
import BaseLayout from "../../../components/en/index_layout";
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useRouter } from "next/router";
import { ServiceBoard } from "../../../components/en/board/serviceboard";
import { PrivacyBoard } from "../../../components/en/board/privacyboard";

export default function BoardIndex() {
  const router = useRouter();
  const [title, setTitle] = useState("Terms");
  const {
    query: { page },
  } = router;
  const { status } = router.query;

  useEffect(() => {
    if (status) {
      setTitle(status);
    }
  }, [page, status]);
  const transferMenu = async (e) => {
    router.push(`/en/board/home?status=${e.target.value}`);
  };

  return (
    <BaseLayout>
      <Box className="mypage">
        <Box className="mypage_menu">
          <ul>
            <li>
              <button
                onClick={transferMenu}
                value="Terms"
                className={title === "Terms" ? "active" : ""}
              >
                Terms
              </button>
            </li>
            <li>
              <button
                onClick={transferMenu}
                value="Privacy"
                className={title === "Privacy" ? "active" : ""}
              >
                Privacy
              </button>
            </li>
          </ul>
        </Box>
        {title === "Terms" ? (
          <ServiceBoard />
        ) : title === "Privacy" ? (
          <PrivacyBoard />
        ) : (
          <Box className="mypage_content"></Box>
        )}
      </Box>
    </BaseLayout>
  );
}
